"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _FeatureFlagView_ffKey_accessor_storage, _FeatureFlagView_ffFlagIdentifier_accessor_storage, _FeatureFlagView_ffTargetIdentifier_accessor_storage, _FeatureFlagView_ffTargetAttributes_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagView = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const ff_javascript_client_sdk_1 = require("@harnessio/ff-javascript-client-sdk");
let FeatureFlagView = class FeatureFlagView extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _FeatureFlagView_ffKey_accessor_storage.set(this, '');
        _FeatureFlagView_ffFlagIdentifier_accessor_storage.set(this, '');
        _FeatureFlagView_ffTargetIdentifier_accessor_storage.set(this, '');
        _FeatureFlagView_ffTargetAttributes_accessor_storage.set(this, {});
        Object.defineProperty(this, "flagValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "updateInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "updateFlagValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (flagValue) => {
                console.log('Updating flag value', flagValue);
                const onFlagValueChange = new CustomEvent('onFlagValueChange', {
                    bubbles: true,
                    composed: true,
                    detail: flagValue,
                });
                this.dispatchEvent(onFlagValueChange);
                this.flagValue = flagValue;
                this.requestUpdate();
            }
        });
    }
    // See Harness JS Docs
    // https://github.com/harness/ff-javascript-client-sdk
    get ffKey() { return __classPrivateFieldGet(this, _FeatureFlagView_ffKey_accessor_storage, "f"); }
    set ffKey(value) { __classPrivateFieldSet(this, _FeatureFlagView_ffKey_accessor_storage, value, "f"); }
    get ffFlagIdentifier() { return __classPrivateFieldGet(this, _FeatureFlagView_ffFlagIdentifier_accessor_storage, "f"); }
    set ffFlagIdentifier(value) { __classPrivateFieldSet(this, _FeatureFlagView_ffFlagIdentifier_accessor_storage, value, "f"); }
    get ffTargetIdentifier() { return __classPrivateFieldGet(this, _FeatureFlagView_ffTargetIdentifier_accessor_storage, "f"); }
    set ffTargetIdentifier(value) { __classPrivateFieldSet(this, _FeatureFlagView_ffTargetIdentifier_accessor_storage, value, "f"); }
    get ffTargetAttributes() { return __classPrivateFieldGet(this, _FeatureFlagView_ffTargetAttributes_accessor_storage, "f"); }
    set ffTargetAttributes(value) { __classPrivateFieldSet(this, _FeatureFlagView_ffTargetAttributes_accessor_storage, value, "f"); }
    connectedCallback() {
        console.log('Connected to feature-flag-view');
        this.client = (0, ff_javascript_client_sdk_1.initialize)(this.ffKey, {
            identifier: this.ffTargetIdentifier,
            attributes: this.ffTargetAttributes,
        });
        super.connectedCallback();
        this.setupEventListeners();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up interval when component is removed
        if (this.updateInterval) {
            clearTimeout(this.updateInterval);
        }
    }
    setupEventListeners() {
        if (this.client) {
            // Listen for events
            // Event happens when connection to server is established
            this.client.on(ff_javascript_client_sdk_1.Event.READY, (flags) => {
                console.log('Feature flag client initialized:', flags);
            });
            // Event happens when a changed event is pushed
            this.client.on(ff_javascript_client_sdk_1.Event.CHANGED, (changeInfo) => {
                console.log('Feature flag changed:', changeInfo);
                if (changeInfo.flag === this.ffFlagIdentifier) {
                    // Update the flag value when changes occur
                    this.updateFlagValue(changeInfo);
                }
            });
        }
    }
    render() {
        if (!this.flagValue) {
            return (0, lit_1.html) ``;
        }
        else {
            // There's so many variations that can be factored in here... but for now we're just handling basic boolean toggles
            if (this.flagValue.value === true || this.flagValue.value === 'true') {
                console.log('Rendering Feature Flag on state...');
                return (0, lit_1.html) ` <slot name="on"></slot> `;
            }
            else {
                console.log('Rendering Feature Flag off state...');
                return (0, lit_1.html) ` <slot name="off"></slot> `;
            }
        }
    }
};
exports.FeatureFlagView = FeatureFlagView;
_FeatureFlagView_ffKey_accessor_storage = new WeakMap();
_FeatureFlagView_ffFlagIdentifier_accessor_storage = new WeakMap();
_FeatureFlagView_ffTargetIdentifier_accessor_storage = new WeakMap();
_FeatureFlagView_ffTargetAttributes_accessor_storage = new WeakMap();
Object.defineProperty(FeatureFlagView, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: []
});
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FeatureFlagView.prototype, "ffKey", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FeatureFlagView.prototype, "ffFlagIdentifier", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FeatureFlagView.prototype, "ffTargetIdentifier", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], FeatureFlagView.prototype, "ffTargetAttributes", null);
exports.FeatureFlagView = FeatureFlagView = __decorate([
    (0, decorators_js_1.customElement)('feature-flag-view')
], FeatureFlagView);
